import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContent = styled.div`
  background: #282E33;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
`;

export const ModalHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #3B444C;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  color: #B6C2CF;
  font-weight: 500;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #8C9BAB;
  cursor: pointer;
  padding: 0;
  line-height: 1;

  &:hover {
    color: #B6C2CF;
  }
`;

export const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Label = styled.h4`
  margin: 0;
  font-size: 14px;
  color: #B6C2CF;
  font-weight: 500;
`;

export const RadioGroup = styled.div`
  display: flex;
  gap: 16px;
`;

export const RadioLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #B6C2CF;
  cursor: pointer;
`;

export const RadioInput = styled.input`
  cursor: pointer;
`;

export const SliderGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Slider = styled.input`
  flex-grow: 1;
`;

export const SliderValue = styled.span`
  font-size: 14px;
  color: #B6C2CF;
  background: #22272B;
  padding: 4px 8px;
  border-radius: 4px;
  min-width: 40px;
  text-align: center;
`;
